import React from 'react';

export default ({
  children,
  className,
  topBar
}: {
  children: React.ReactNode;
  className?: string;
  topBar?: React.ReactNode;
}) => {
  return (
    <div
      className={`align-top h-[330px] min-h-[330px] ev-sm:h-[calc(98vh-205px)] ev-sm:min-h-[calc(98vh-205px)] w-full ev-sm:flex-1 min-w-0 ${className}`}
    >
      {topBar}
      <div className="max-h-[330px] ev-sm:max-h-[calc(100vh-205px)] overflow-auto p-6 pt-4 pb-2 ev-sm:pb-6 ev-sm:pt-6 ev-sm:pr-8">
        {children}
      </div>

      <div className="italic px-6 pb-4 font-medium ev-sm:hidden">
        This is a limited version of the editor. Use a larger screen to access all features
      </div>
    </div>
  );
};
